const getHexFromRgbObject = (color: any): string => {
  const { r, g, b } = color;
  const rHex = r.toString(16).padStart(2, "0");
  const gHex = g.toString(16).padStart(2, "0");
  const bHex = b.toString(16).padStart(2, "0");
  return `#${rHex}${gHex}${bHex}`;
};

export default getHexFromRgbObject;
